import { Box, Text, TextProps } from '@jfs/ui-new'
import { isStringBlank } from '../../util/util'
const getDateView = (entry: any, textStyles?: TextProps) => {
  return (
    <Box f={1}>
      <Text {...textStyles}>{isStringBlank(entry?.value) ? 'NA' : entry?.value}</Text>
    </Box>
  )
}

export { getDateView }
